import { gatewayFetcher } from './gatewayFetcher';

export const getInvitationInfo = async token => {
  const { data } = await gatewayFetcher.get('/campaign-registration/info', {
    params: { token },
  });
  return data;
};
